(function($) {
listToggle = function() {
    $('.list-toggle').hover(function(){
        
    });
};
})(jQuery);
